import type { Player } from '../types/player';
import { normalizeText } from './teams';

const HEADER_WORDS = new Set([
  'player', 'players', 'name', 'team', 'pos', 'position', 'slot', 'opp', 'rank',
  'proj', 'projection', 'points', 'owner', 'status', 'roster',
]);

export function splitRosterLines(raw: string): string[] {
  return raw
    .split(/\r?\n/)
    .map((line) => line.replace(/^["']+|["']+$/g, '').trim())
    .filter(Boolean);
}

export function extractPlayerName(line: string): string {
  const cleaned = line
    .replace(/^\d+[\).:\s-]+/, '')
    .replace(/\s+\(([^)]+)\)\s*$/, '')
    .trim();
  const parts = cleaned.split(/\s{2,}|\t+|,(?=\s*[A-Z]{2,3}\b)/);
  const first = (parts[0] || cleaned).trim();
  const tokens = first.split(/\s+/).filter(Boolean);
  if (tokens.length >= 2 && /^[A-Z]{1,3}$/.test(tokens[tokens.length - 1])) {
    return tokens.slice(0, -1).join(' ');
  }
  return first;
}

export function parsePastedRoster(
  raw: string,
  board: Player[]
): { players: Player[]; unmatched: string[] } {
  const lines = splitRosterLines(raw);
  const byName = new Map(
    board.map((player) => [normalizeText(player.name), player])
  );
  const players: Player[] = [];
  const unmatched: string[] = [];
  const used = new Set<string>();

  for (const line of lines) {
    const name = extractPlayerName(line);
    const key = normalizeText(name);
    const tokens = key.split(' ').filter(Boolean);
    if (!key || HEADER_WORDS.has(key) || tokens.every((token) => HEADER_WORDS.has(token))) continue;
    const hit = byName.get(key);
    if (hit && !used.has(String(hit.id))) {
      players.push(hit);
      used.add(String(hit.id));
    } else if (!hit) {
      unmatched.push(name);
    }
  }

  return { players, unmatched };
}
